// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__1bGlW","obliqueLineWrap":"membershipbadge_obliqueLineWrap__19wc6","obliqueLine":"membershipbadge_obliqueLine__1p9W8"};